import { styled } from 'styled-components';
import { SelectionCardStrip } from '../../core-components';
export const StyledCardStrip = styled(SelectionCardStrip.Wrapper).withConfig({
  componentId: "aui__sc-41bdtr-0"
})(["display:flex;align-items:center;width:100%;"]);
export const IconWrapper = styled.div.withConfig({
  componentId: "aui__sc-41bdtr-1"
})(["margin-right:0.5rem;align-self:flex-start;"]);
export const ChevronWrapper = styled.div.withConfig({
  componentId: "aui__sc-41bdtr-2"
})(["color:currentColor;margin-left:auto;padding-left:0.5rem;"]);